import { render, staticRenderFns } from "./DispensationMessages.vue?vue&type=template&id=5e19d13e&scoped=true&"
import script from "./DispensationMessages.vue?vue&type=script&lang=js&"
export * from "./DispensationMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e19d13e",
  null
  
)

export default component.exports